<template>
  <label :for="forId" class="text-sm" :class="className" v-html="content"></label>
</template>

<script>
export default {
  name: 'InputLabel',
  props: {
    forId: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: 'text-black',
    },
    content: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>

<style scoped>
label {
  color: var(--color-green-dark);
}
.top-01 {
  top: -0.1rem;
}
.label-white {
  color: #fff;
}
</style>
